import React, { useEffect } from 'react'
import QRCode from 'qrcode'
import './qr.css'

const QRGenerator = ({ link }) => {
  useEffect(() => {
    const canvas = document.getElementById('qrCanvas')
    if (canvas && link) {
      QRCode.toCanvas(canvas, link, { width: 150 }, (error) => {
        if (error) console.error(error)
      })
    }
  }, [link])

  const downloadQR = () => {
    const canvas = document.getElementById('qrCanvas')
    if (!canvas) return

    const imageURL = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream')

    const link = document.createElement('a')
    link.download = 'qr-image.png'
    link.href = imageURL
    link.click()
  }

  return (
    <>
      <div className="flex flex-col items-center">
        <canvas id="qrCanvas" className="qr-canvas"></canvas>

        <span
          onClick={downloadQR}
          className="font-semibold text-white mt-1 cursor-pointer"
        >
          Download
        </span>
      </div>
    </>
  )
}

export default QRGenerator
